const html2pdf = require('html2pdf.js');

export function handleShowListingContract() {
    // const listingPage = document.querySelector('#dash-prop-listings') as HTMLElement;
    // const recordPage = document.querySelector('#fy-records-table') as HTMLElement;


    // if (listingPage || recordPage) {
    //     const buttons = document.querySelectorAll('.property-table-listing-contract-btn') as NodeList;
    //     const original = document.querySelector('body') as HTMLElement;
    //     buttons.forEach(btn => {
    //         const contractWrapper = (btn as HTMLElement).nextElementSibling;
    //         const A4Sizes = contractWrapper.childNodes;
    //         const contractPrintBtn = (contractWrapper as HTMLElement).nextElementSibling;
    //         const contractCloseBtn = (contractPrintBtn as HTMLElement).nextElementSibling;

    //         btn.addEventListener('click', e => {
    //             e.preventDefault();
    //             contractWrapper.classList.remove('hide');
    //             contractPrintBtn.classList.remove('hide');
    //             contractCloseBtn.classList.remove('hide');
    //         })

    //         A4Sizes.forEach(A4Size => {
    //             A4Size.addEventListener('click', e=> {
    //                 e.preventDefault();
    //                 e.stopPropagation();
    //                 contractWrapper.classList.remove('hide');
    //                 contractPrintBtn.classList.remove('hide');
    //                 contractCloseBtn.classList.remove('hide');
    //             })
    //         })
            
    //         contractWrapper.addEventListener('click', e => {
    //             e.preventDefault();
    //             contractWrapper.classList.add('hide');
    //             contractPrintBtn.classList.add('hide');
    //             contractCloseBtn.classList.add('hide');
    //         })
    //         contractCloseBtn.addEventListener('click', e => {
    //             e.preventDefault();
    //             contractWrapper.classList.add('hide');
    //             contractPrintBtn.classList.add('hide');
    //             contractCloseBtn.classList.add('hide');
    //         })
    //         contractPrintBtn.addEventListener('click', e => {
    //             e.preventDefault();
    //             e.stopPropagation();
    //             const content = original.innerHTML;
    //             original.innerHTML = contractWrapper.innerHTML;
    //             window.print();
    //             original.innerHTML = content;
    //             handleShowListingContract();
    //         })
    //     })
    // }
}

export function handleShowTourContract() {
    // const tourPage = document.querySelector('#dash-prop-tour') as HTMLElement;
    // const recordPage = document.querySelector('#fy-records-table') as HTMLElement;

    // if (tourPage || recordPage) {
    //     const buttons = document.querySelectorAll('.property-table-tour-contract-btn') as NodeList;
    //     const original = document.querySelector('body') as HTMLElement;
    //     buttons.forEach(btn => {
    //         const contractWrapper = (btn as HTMLElement).nextElementSibling;
    //         const A4Sizes = contractWrapper.childNodes;
    //         const contractPrintBtn = (contractWrapper as HTMLElement).nextElementSibling;
    //         const contractCloseBtn = (contractPrintBtn as HTMLElement).nextElementSibling;

    //         btn.addEventListener('click', e => {
    //             e.preventDefault();
    //             contractWrapper.classList.remove('hide');
    //             contractPrintBtn.classList.remove('hide');
    //             contractCloseBtn.classList.remove('hide');
    //         })

    //         A4Sizes.forEach(A4Size => {
    //             A4Size.addEventListener('click', e=> {
    //                 e.preventDefault();
    //                 e.stopPropagation();
    //                 contractWrapper.classList.remove('hide');
    //                 contractPrintBtn.classList.remove('hide');
    //                 contractCloseBtn.classList.remove('hide');
    //             })
    //         })
            
    //         contractWrapper.addEventListener('click', e => {
    //             e.preventDefault();
    //             contractWrapper.classList.add('hide');
    //             contractPrintBtn.classList.add('hide');
    //             contractCloseBtn.classList.add('hide');
    //         })
    //         contractCloseBtn.addEventListener('click', e => {
    //             e.preventDefault();
    //             contractWrapper.classList.add('hide');
    //             contractPrintBtn.classList.add('hide');
    //             contractCloseBtn.classList.add('hide');
    //         })
    //         contractPrintBtn.addEventListener('click', e => {
    //             e.preventDefault();
    //             e.stopPropagation();
    //             const content = original.innerHTML;
    //             original.innerHTML = contractWrapper.innerHTML;
    //             window.print();
    //             original.innerHTML = content;
    //             handleShowTourContract();
    //         })
    //     })
    // }
}

export function handleShowOfferContract() {
    const offerPage = document.querySelector('#dash-prop-offer') as HTMLElement;
    const recordPage = document.querySelector('#fy-records-table') as HTMLElement;

    if (offerPage || recordPage) {
        const buttons = document.querySelectorAll('.property-table-offer-contract-btn') as NodeList;
        const original = document.querySelector('body') as HTMLElement;
        buttons.forEach(btn => {
            const contractWrapper = (btn as HTMLElement).nextElementSibling;
            const A4Sizes = contractWrapper.childNodes;
            const contractPrintBtn = (contractWrapper as HTMLElement).nextElementSibling;
            const contractCloseBtn = (contractPrintBtn as HTMLElement).nextElementSibling;

            document.addEventListener('keyup', e => {
                if(e.key === 'Escape') {
                    e.preventDefault();
                    contractWrapper.classList.add('hide');
                    contractPrintBtn.classList.add('hide');
                    contractCloseBtn.classList.add('hide');
                }
            })

            btn.addEventListener('click', e => {
                e.preventDefault();
                contractWrapper.classList.remove('hide');
                contractPrintBtn.classList.remove('hide');
                contractCloseBtn.classList.remove('hide');
            })

            A4Sizes.forEach(A4Size => {
                A4Size.addEventListener('click', e=> {
                    e.preventDefault();
                    e.stopPropagation();
                    contractWrapper.classList.remove('hide');
                    contractPrintBtn.classList.remove('hide');
                    contractCloseBtn.classList.remove('hide');
                })
            })
            
            contractWrapper.addEventListener('click', e => {
                e.preventDefault();
                contractWrapper.classList.add('hide');
                contractPrintBtn.classList.add('hide');
                contractCloseBtn.classList.add('hide');
            })
            contractCloseBtn.addEventListener('click', e => {
                e.preventDefault();
                contractWrapper.classList.add('hide');
                contractPrintBtn.classList.add('hide');
                contractCloseBtn.classList.add('hide');
            })
            contractPrintBtn.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                const content = original.innerHTML;
                // Remove class "beforePrint" before generate pdf contract.
                A4Sizes.forEach(A4Size => {
                    if ((A4Size as HTMLElement).nextElementSibling && (A4Size as HTMLElement).nextElementSibling.classList) {
                        (A4Size as HTMLElement).nextElementSibling.classList.remove('beforePrint');
                    }
                })
                original.innerHTML = contractWrapper.innerHTML;
                // Using html2pdf library
                let userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
                let opt = {};
                if (/windows phone/i.test(userAgent) || /android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream)) {
                    opt = {
                        margin:       [10, 10, 10, 10],
                        pagebreak: { mode: ['css']},
                        filename:     'contract.pdf',
                    }
                } else {
                    opt = {
                        margin:       [10, 10, 10, 10],
                        pagebreak: { mode: ['css']},
                        filename:     'contract.pdf',
                        html2canvas: {
                            // dpi: 192,
                            scale:4,
                            // letterRendering: true,
                            // useCORS: true
                        },
                        // jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
                    }
                }

                html2pdf().from(contractWrapper.innerHTML).set(opt).save();
                
                original.innerHTML = content;
                handleShowOfferContract();
            })
        })
    }
}

export function handleShowModal() {
    const tourPage = document.querySelector('#dash-prop-tour') as HTMLElement;
    const recordPage = document.querySelector('#fy-records-table') as HTMLElement;

    if (!(tourPage || recordPage)) {
        return;
    }

    // Event(Esc close) for id-card modal, tour msg modal, offer remarks modal
    const buttons = document.querySelectorAll('.msg-btn') as NodeList;
    if (buttons) {
        buttons.forEach(btn => {
            const contractWrapper = (btn as HTMLElement).nextElementSibling;
            const closeBtn = contractWrapper.querySelector('.msg-close') as HTMLSpanElement;
            
            document.addEventListener('keyup', e => {
                if(e.key === 'Escape') {
                    e.preventDefault();
                    closeBtn.click();
                }
            })
        })
    }
}